export function heroForm() {
    const $heroSection = $(".hero-section.with-bg");
    let $form;
    const $window = $(window);
    let indentFromTop;
    let indentFormBottom;

    function heroForm() {
        $heroSection.each(function () {
            let $this = $(this);
            $form = $this.next(".form-for-hero");

            let heroHeight = $this.innerHeight();
            let formHeight = $form.innerHeight();
            if ($window.innerWidth() >= 1800) {
                indentFromTop = 232;
                indentFormBottom = 90;
            } else if ($window.innerWidth() >= 1200) {
                indentFromTop = 150;
                indentFormBottom = 50;
            } else {
                indentFromTop = 100;
                indentFormBottom = 50;
            }
            if ($window.innerWidth() >= 1024) {
                $form.css({
                    "margin-top": -(heroHeight - indentFromTop)
                });
                if (heroHeight < formHeight + indentFromTop) {
                    $form.css({
                        "margin-bottom": indentFormBottom
                    });
                } else {
                    $form.css({
                        "margin-bottom": (heroHeight - (formHeight + indentFromTop) + indentFormBottom)
                    });
                    if ($window.innerHeight() >= 1200) {
                        $form.css({
                            "margin-top": -((heroHeight / 2) + (formHeight / 2)),
                            "margin-bottom": (heroHeight / 2 - (formHeight / 2) + indentFormBottom)
                        });
                    }
                }
            } else {
                $form.css({
                    "margin-top": 0,
                    "margin-bottom": indentFormBottom
                });
            }
        });
    }

    $(window).on("load resize", function () {
        heroForm();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroForm.js